/* Forzono — scroll-linked motion (no dependencies).
   Gives the rest of the page the same scroll-driven feel as the 3D ring: scrubbed image reveals,
   word-by-word headings, depth-staggered cards and a spinning ornament. Respects prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__forzonoFx) return;
  window.__forzonoFx = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var items = [];
  var visible = new Set();
  var io, raf = 0, lastY = -1, mobile = function () { return window.innerWidth < 750; };

  function splitWords(el) {
    if (el.dataset.fxSplit) return [];
    el.dataset.fxSplit = '1';
    var out = [];
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span');
            s.className = 'fx-word'; s.textContent = part; frag.appendChild(s); out.push(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
      });
    })(el);
    el.classList.add('fx-words');
    return out;
  }

  function add(el, type, opts) {
    if (!el || el.__fx) return;
    el.__fx = true;
    var item = { el: el, type: type, o: opts || {}, cur: 0, words: null };
    if (type === 'words') item.words = splitWords(el);
    items.push(item);
    io.observe(el);
  }

  function scan(scope) {
    scope = scope || document;
    var q = function (sel) { return Array.prototype.slice.call(scope.querySelectorAll(sel)); };
    q('.image-text__media').forEach(function (el) { add(el, 'clip'); });
    q('.image-text__content').forEach(function (el) { add(el, 'drift', { amp: -28 }); });
    q('.statement .ornament').forEach(function (el) { add(el, 'spin'); });
    q('.section-head .h1, .statement__heading, .image-text__content .h1, .appointment .h1, .visit .h1, .jr-manifesto__title').forEach(function (el) { add(el, 'words'); });
    q('.decor__layer[data-speed]').forEach(function (el) {
      var host = el.closest('.section') || el.parentNode;
      add(el, 'parallax', { speed: parseFloat(el.getAttribute('data-speed')) || 0.2, host: host });
    });
    q('.curated__grid').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { add(c, 'rise', { amp: 24 + (i % 4) * 18 }); });
    });
    q('.services__grid').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { add(c, 'rise', { amp: 28 + i * 22 }); });
    });
    q('.product-grid').forEach(function (g) {
      var first = g.firstElementChild, cols = 4;
      if (first && first.clientWidth && g.clientWidth) cols = Math.max(1, Math.round(g.clientWidth / first.clientWidth));
      Array.prototype.forEach.call(g.children, function (c, i) { add(c, 'rise', { amp: 14 + (i % cols) * 14 }); });
    });
    kick();
  }

  var vh = window.innerHeight;
  window.addEventListener('resize', function () { vh = window.innerHeight; });
  function progress(el) {
    var r = el.getBoundingClientRect();
    return clamp((vh - r.top) / (vh + r.height), 0, 1);
  }

  // write a style only when its value changes
  function set(node, prop, val) {
    var c = node.__fxc || (node.__fxc = {});
    if (c[prop] === val) return;
    c[prop] = val;
    if (prop.charAt(0) === '-') node.style.setProperty(prop, val); else node.style[prop] = val;
  }
  function apply(it, p) {
    var el = it.el;
    switch (it.type) {
      case 'clip': {
        var t = clamp(p / 0.42, 0, 1); t = 1 - Math.pow(1 - t, 3);
        set(el, '--fx-clip', ((1 - t) * 16).toFixed(2) + '%');
        var img = it.img || (it.img = el.querySelector('img, .placeholder'));
        if (img) set(img, 'transform', 'scale(' + (1.16 - 0.16 * t - (p - 0.4) * 0.04).toFixed(3) + ')');
        break;
      }
      case 'drift':
        if (!mobile()) set(el, 'translate', '0 ' + ((0.5 - p) * it.o.amp * 2).toFixed(1) + 'px');
        break;
      case 'rise':
        set(el, 'translate', '0 ' + ((1 - clamp(p / 0.6, 0, 1)) * it.o.amp).toFixed(1) + 'px');
        break;
      case 'parallax':
        set(el, 'transform', 'translate3d(0,' + ((0.5 - p) * it.o.speed * vh).toFixed(1) + 'px,0)');
        break;
      case 'spin':
        set(el, 'transform', 'perspective(500px) rotateY(' + (p * 540 - 180).toFixed(1) + 'deg)');
        break;
      case 'words': {
        var w = it.words, n = w.length;
        if (!n) break;
        var f = clamp((p - 0.12) / 0.4, 0, 1) * (n + 2) - 1;
        for (var i = 0; i < n; i++) {
          var o = clamp(f - i + 1, 0, 1);
          set(w[i], 'opacity', (0.16 + 0.84 * o).toFixed(2));
        }
        break;
      }
    }
  }

  function frame() {
    raf = 0;
    var moving = false;
    var list = [];
    visible.forEach(function (el) { if (el.__fxItem) list.push([el.__fxItem, progress(el)]); });   // all reads first
    list.forEach(function (e) {                                                                    // then all writes
      var it = e[0], target = e[1];
      it.cur += (target - it.cur) * 0.14;
      if (Math.abs(target - it.cur) > 0.0015) moving = true; else it.cur = target;
      apply(it, it.cur);
    });
    if (moving) raf = requestAnimationFrame(frame);
  }
  function kick() { if (!raf) raf = requestAnimationFrame(frame); }

  function init() {
    if (!('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var it = items.filter(function (x) { return x.el === e.target; })[0];
        if (!it) return;
        e.target.__fxItem = it;
        if (e.isIntersecting) { visible.add(e.target); if (!it.seeded) { it.cur = progress(e.target); it.seeded = true; apply(it, it.cur); } }
        else visible.delete(e.target);
      });
      kick();
    }, { rootMargin: '10% 0px' });
    document.documentElement.classList.add('fx-on');
    scan(document);
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { if (io) scan(e.target); });
})();
